import(/* webpackMode: "eager" */ "/vercel/path0/lib/components/breadcrumbs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/lib/components/faq.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/lib/components/favorites.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/lib/components/footer.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/lib/components/get-theme-button.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/lib/components/microsoft-clarity.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/lib/components/navbar.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/lib/components/skeletons.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/lib/components/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/lib/ui/components/toaster.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager", webpackExports: ["NextUIProvider"] */ "/vercel/path0/node_modules/@nextui-org/system/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
